import type { AnalyticsEvent } from "@decocms/apps-commerce/types"

export const sendEvent = <E extends AnalyticsEvent>(event: E) => {
    if (typeof window !== 'undefined' && window.DECO?.events) {
        // The framework injects both dispatch (publish) and subscribe at
        // runtime, but the upstream Window augmentation in @decocms/apps-commerce only
        // exposes `subscribe`. Cast locally so we can still publish.
        const events = window.DECO.events as { dispatch?: (event: unknown) => void }
        events.dispatch?.(event)
    }
}
